/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for requesting a password reset e-mail.
 * @export
 * @interface CustomPasswordReset
 */
export interface CustomPasswordReset {
    /**
     * 
     * @type {string}
     * @memberof CustomPasswordReset
     */
    email: string;
}

/**
 * Check if a given object implements the CustomPasswordReset interface.
 */
export function instanceOfCustomPasswordReset(value: object): value is CustomPasswordReset {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function CustomPasswordResetFromJSON(json: any): CustomPasswordReset {
    return CustomPasswordResetFromJSONTyped(json, false);
}

export function CustomPasswordResetFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPasswordReset {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

  export function CustomPasswordResetToJSON(json: any): CustomPasswordReset {
      return CustomPasswordResetToJSONTyped(json, false);
  }

  export function CustomPasswordResetToJSONTyped(value?: CustomPasswordReset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

